import {
  deleteRequestGeneric,
  getRequestGeneric,
  postRequestGeneric,
  putRequestGeneric,
} from '@/services/backendApiGeneric'

/**
 * Textbausteine für das Nachrichtenfenster (Inhaber-Feedback 15.08.2026, I.4).
 *
 * Ein Baustein gehört entweder dem angemeldeten Benutzer oder dem ganzen
 * Unternehmen (`shared` = "für alle Mitarbeitenden"; nur Administrator und
 * Unternehmensleiter dürfen diese anlegen und ändern). `editable` sagt, ob
 * der angemeldete Nutzer den Baustein ändern darf.
 */
export interface TextSnippet {
  id: number
  idOrganization: number
  idUser: number | null
  title: string
  /** HTML-Inhalt (Editor-Fragment). */
  content: string
  sortOrder: number
  createdAt: string
  updatedAt: string
  shared: boolean
  editable: boolean
}

export interface TextSnippetInput {
  title: string
  content: string
  shared: boolean
  sortOrder?: number
}

/**
 * Eigene + Unternehmens-Bausteine (vollständige Liste). Die Suche „ab dem
 * ersten Buchstaben“ läuft clientseitig im TextSnippetDialog.
 */
export function listTextSnippets (): Promise<TextSnippet[]> {
  return getRequestGeneric('/protected/text-snippets')
}

export function createTextSnippet (input: TextSnippetInput): Promise<TextSnippet> {
  return postRequestGeneric('/protected/text-snippets', input, true)
}

export function updateTextSnippet (id: number, input: TextSnippetInput): Promise<TextSnippet> {
  return putRequestGeneric(`/protected/text-snippets/${id}`, input, true)
}

export function deleteTextSnippet (id: number): Promise<any> {
  return deleteRequestGeneric(`/protected/text-snippets/${id}`)
}
